"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _noop = _interopRequireDefault(require("lodash/fp/noop"));
var _runtimeDetectProxies = _interopRequireDefault(require("./runtimeDetectProxies"));
var lockManager = new Map();
var getLockManager = function getLockManager(element) {
  var counter = {
    _count: 0,
    getCount: function getCount() {
      return this._count;
    },
    increase: function increase() {
      this._count++;
    },
    decrease: function decrease() {
      this._count--;
    }
  };
  var cacheStyle = new Map();
  if (lockManager.has(element)) {
    return lockManager.get(element);
  }
  lockManager.set(element, {
    counter: counter,
    cacheStyle: cacheStyle
  });
  return {
    counter: counter,
    cacheStyle: cacheStyle
  };
};
var ScrollHelper = /*#__PURE__*/function () {
  function ScrollHelper(element) {
    (0, _classCallCheck2["default"])(this, ScrollHelper);
    this._element = element || document.body;
    var _getLockManager = getLockManager(this._element),
      counter = _getLockManager.counter,
      cacheStyle = _getLockManager.cacheStyle;
    this._counter = counter;
    this._cacheStyle = cacheStyle;
  }
  return (0, _createClass2["default"])(ScrollHelper, [{
    key: "lockScroll",
    value: function lockScroll() {
      this._counter.increase();
      if (this._counter.getCount() > 1) return;
      var actualValue = this._element.style.getPropertyValue('overflow');
      if (actualValue) {
        this._cacheStyle.set('overflow', actualValue);
      }
      this._element.style.setProperty('overflow', 'hidden');
    }
  }, {
    key: "unlockScroll",
    value: function unlockScroll() {
      this._counter.decrease();
      if (this._counter.getCount() > 0) return;
      var actualValue = this._cacheStyle.get('overflow');
      if (!actualValue) {
        this._element.style.removeProperty('overflow');
      } else {
        this._element.style.setProperty('overflow', actualValue);
        this._cacheStyle.clear();
      }
    }
  }]);
}();
var _default = exports["default"] = (0, _runtimeDetectProxies["default"])({
  target: ScrollHelper,
  nonBrowserInstance: {
    lockScroll: _noop["default"],
    unlockScroll: _noop["default"]
  }
});